var exports = {
  "Q": "PendingFriendsView.module__pendingViewContainer___WlZsOD",
  "X": "PendingFriendsView.module__scroller___WlZsOD",
};

module.exports = exports;
